import React, { useState, useEffect } from "react";
import styles from "../assets/css/UserList.module.css";
import common from "../assets/css/common.module.css";
import { redirect, useNavigate } from "react-router-dom";
import { postData1 } from "../../services";
import { DownloadToExcel, Pagination } from "../Common";
import { Loader } from "../../components/Loader";
import { AiOutlineUp, AiOutlineDown } from "react-icons/ai";


const sortIconStyle = {
  cursor: "pointer",
  marginLeft: "5px",
};

export const NewEquipList = () => {
  const navigate = useNavigate();
  const [newAdslistData, setNewAdsListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: "asc",
  });

  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [query, setQuery] = useState("")

// console.log("NewAdslistData", newAdslistData)
  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
  };

  const handleSorting = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true); // Start loading
      try {
        const config = { post_type: 2, _page: currPage, _limit: itemsPerPage ,  search: query || ""};
        const res = await postData1("admin/product_list/", config, true, true);

        const sortedData = res?.data?.data.sort((a, b) => {
          const valA = a[sortConfig.key] ?? "";
          const valB = b[sortConfig.key] ?? "";

          if (sortConfig.direction === "asc") {
            return valA > valB ? 1 : -1;
          } else {
            return valA < valB ? 1 : -1;
          }
        });

        setNewAdsListData(sortedData);
        setPaging({
          total: res?.data?.total,
          total_pages: res?.data?.total_pages,
        });
      } catch (error) {
        console.error("Error fetching equipment list:", error);
        // Optionally show an error message to the user here
      } finally {
        setLoader(false); // Stop loading no matter what
      }
    };

    fetchData();
  }, [currPage, sortConfig, itemsPerPage, query]);

  // Fixed filter function
  

  const handleView = (e, data) => {
    navigate("/admin/manageneweqip/viewuser/", {
      state: {
        productId: data.id
      }
    });
  };

      const excelData = newAdslistData.map((data) => ({
      ProductId: data.id,
      PorductName: data.equip_name,
      Category: data.category_list,
      SubCategory: data.subcategory,
      Specelities: data.speciality_name,
      AskingPrice: data.asking_price,
      Warranty: data.warranty,
      ProductType:data.post_type === 1 ? "Pre Owned" : data.post_type === 2 ?" New" :data.post_type === 3 ? "Spare&Accessories" :"Services" ,
      metaTitle: data.seo_data?.title || "",
      metaDescription: data.seo_data?.description || "",
      keywords: data.seo_data?.keywords || "",
    }));

  return (
    <>
      <section className={styles.userListCont}>
        <div className={styles.listHead}>
          <h1>NEW EQUIPMENT</h1>
          <div className="w-[40%] flex items-center border border-[#019c89] rounded-md px-3 py-1 shadow-sm ">
            <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
            <input
              type="text"
              placeholder="Search by name, brand, category, speciality..."
              className="w-full outline-none bg-transparent text-[#019c89] placeholder-[#019c89]"
              value={query}
              onChange={(e) => { setQuery(e.target.value); setCurrPage(1);}}
            />
          </div>

          {/* <div className=" w-8 h-8">
          <DownloadToExcel data={excelData} filename={`Product-page-${currPage}`} />
         </div> */}

        </div>
        <div className={styles.dataItems}>
          <div className={styles.itemHead}>
            <span onClick={() => handleSorting("id")}>
              PRODUCT ID
              {sortConfig.key === "id" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("seller_name")}>
              Name
              {sortConfig.key === "seller_firstname" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("seller_firstname")}>
              OWNER
              {sortConfig.key === "seller_firstname" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("equip_name")}>
              EQUIP NAME
              {sortConfig.key === "equip_name" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("equipname_list")}>
              CATEGORY
              {sortConfig.key === "equipname_list" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("speciality_name")}>
              SPECIALITY
              {sortConfig.key === "speciality_name" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("asking_price")}>
              ASK PRICE
              {sortConfig.key === "asking_price" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("brand")}>
              BRAND
              {sortConfig.key === "brand" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            {/* <span onClick={() => handleSorting("warranty")}>
              WARRANTY
              {sortConfig.key === "warranty" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span> */}

            <span onClick={() => handleSorting("address")}>
              CITY
              {sortConfig.key === "address" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("change_owner")}>
              CHANGE OWNER
              {sortConfig.key === "warranty" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("extra-des")}>
              PRODUCT DES
              {sortConfig.key === "extra-des" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span onClick={() => handleSorting("product_status")}>
              STATUS
              {sortConfig.key === "product_status" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
            </span>
            <span>DETAIL</span>
          </div>


          {newAdslistData.length > 0 ? (
            newAdslistData.map((data, index) => {
              // console.log("ss", data)
              return (
                <div className={styles.itemData} key={index}>
                  <span>{data?.id}</span>
                  <span>{data?.seller_name}</span>
                  <span>{data?.seller_firstname}</span>
                  <span
                    onClick={() => window.open(`https://www.equipmedy.com/${data?.slug}`, '_blank', 'noopener,noreferrer')}
                    className="cursor-pointer"
                  >{data?.equip_name}</span>
                  <span>{data?.category_list}</span>
                  <span>{data?.speciality_name?.slice(0, 10)}</span>
                  <span>{parseFloat(data?.asking_price).toFixed(2)}</span>
                  <span>{data?.brand}</span>
                  {/* <span>{data?.warranty === 1 ? "Yes" : "No"}</span> */}
                  <span>{data?.address?.slice(0, 20)}</span>
                  <span className="cursor-pointer bg-green-600 text-white py-1 rounded-full"
                    onClick={() => navigate("/admin/change-owner/", { state: { data: data } })}
                  >Change</span>
                  <span
                    className="cursor-pointer bg-green-600 text-white py-1 rounded-full"
                    // className={common.customStyle}

                    onClick={() => navigate("/admin/product-description/", {
                      state: {
                        data: data,
                        type: "product"
                      }
                    })}
                  >Add</span>
                  <span>
                    <span className={common.customStyle}>
                      {data?.product_status === 1
                        ? "OPEN"
                        : data?.product_status === 2
                          ? "LOCK"
                          : data?.product_status === 3
                            ? "Selled"
                            : data?.product_status === 4
                              ? "PENDING"
                              : ""}
                    </span>
                  </span>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleView(e, data)}
                  >
                    View
                  </span>
                </div>
              );
            })
          ) : (
            <div className="flex items-center justify-center text-gray-500 py-4">
              <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
              <span>No results found</span>
            </div>
          )}

        </div>

        {loader && <Loader />}
      </section>

      <Pagination
        total={paging?.total}
        perPage={itemsPerPage}
        setPerPage={setItemsPerPage}
        currPage={currPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
        setCurrPage={setCurrPage} // Add this prop
      />
    </>
  );
};


export const UsedEquipList = () => {
  const navigate = useNavigate();
  const [usedAdslistData, setUsedAdsListData] = useState([]);
  const [loader, setLoader] = useState(true);
  const [currPage, setCurrPage] = useState(1);
  const [paging, setPaging] = useState({});
  const [prevPage, setPrevPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({
    key: "id",
    direction: "asc",
  });

  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [query, setQuery] = useState("")

  const updatePage = (e) => {
    let name = e.currentTarget.name;
    if (name === "prev") {
      setCurrPage(currPage === 1 ? 1 : currPage - 1);
      setPrevPage(currPage);
    } else if (name === "next") {
      setCurrPage(currPage === paging?.total_pages ? currPage : currPage + 1);
      setPrevPage(currPage);
    } else {
      setCurrPage(parseInt(e.currentTarget.innerHTML));
    }
  };

  const handleSorting = (column) => {
    let direction = "asc";
    if (sortConfig.key === column && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: column, direction });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true); // Start loader
      try {
        const config = { post_type: 1, _page: currPage, _limit: itemsPerPage, search: query || "" };
        const res = await postData1("admin/product_list/", config, true, true);

        const sortedData = res?.data?.data.sort((a, b) => {
          const valA = a[sortConfig.key] ?? "";
          const valB = b[sortConfig.key] ?? "";

          if (sortConfig.direction === "asc") {
            return valA > valB ? 1 : -1;
          } else {
            return valA < valB ? 1 : -1;
          }
        });

        setUsedAdsListData(sortedData);
        setPaging({
          total: res?.data?.total,
          total_pages: res?.data?.total_pages,
        });
      } catch (error) {
        console.error("Error fetching used equipment list:", error);
        // Optionally, show a toast or alert to user here
      } finally {
        setLoader(false); // Stop loader no matter what
      }
    };

    fetchData();
  }, [currPage, sortConfig, itemsPerPage, query]);


  const handleView = (e, data) => {
    navigate("/admin/manageneweqip/viewuser/", {
      state: {
        productId: data.id
      }
    });
  };
//  console.log("data", usedAdslistData)
    const excelData = usedAdslistData.map((data) => ({
      ProductId: data.id,
      PorductName: data.equip_name,
      Category: data.category_list,
      SubCategory: data.SubCategory,
      Specelities: data.speciality_name,
      AskingPrice: data.asking_price,
      Warranty: data.warranty,
      ProductStatus:data.product_status === 1 ? "Pre Owned" : data.product_status === 2 ?" New" :data.product_status === 3 ? "Spare&Accessories" :"Services" ,
      // "Order ID": data?.id,
      metaTitle: data.seo_data?.title || "",
      metaDescription: data.seo_data?.description || "",
      keywords: data.seo_data?.keywords || "",
      // "Order Date": data?.created_date ? new Date(data.created_date).toLocaleDateString() : "",
      // Buyer: data?.buyer_firstname || "",
      // "buyer_phone": data?.buyer_phone || "",
      // "buyer_email": data?.buyer_email || "",
      // Seller: data?.seller_firstname || "",
      // Status: orderStatus[data?.order_status] || "",
      // Quantity: data?.quantity || "",
    }));
  

  return (
    <section className={styles.userListCont}>
      <div className={styles.listHead}>
        <h1>USED EQUIPMENT</h1>
        <div className="w-[40%] flex items-center border border-[#019c89] rounded-md px-3 py-1 shadow-sm ">
          <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
          <input
            type="text"
            placeholder="Search by name, brand, category, speciality..."
            className="w-full outline-none bg-transparent text-[#019c89] placeholder-[#019c89]"
            value={query}
            onChange={(e) => { setQuery(e.target.value); setCurrPage(1); }}
          />
        </div>
         <div className=" w-8 h-8">
          {/* <DownloadToExcel data={excelData} filename={`orders-page-${currPage}`} /> */}
         </div>
      </div>
      <div className={styles.dataItems}>
        <div className={styles.itemHead}>
          <span onClick={() => handleSorting("id")}>
            PRODUCT ID
            {sortConfig.key === "id" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span onClick={() => handleSorting("seller_name")}>
            Name
            {sortConfig.key === "seller_name" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span onClick={() => handleSorting("seller_firstname")}>
            OWNER
            {sortConfig.key === "seller_firstname" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span onClick={() => handleSorting("equip_name")}>
            EQUIP NAME
            {sortConfig.key === "equip_name" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span onClick={() => handleSorting("equipname_list")}>
            CATEGORY
            {sortConfig.key === "equipname_list" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span onClick={() => handleSorting("speciality_name")}>
            SPECIALITY
            {sortConfig.key === "speciality_name" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span onClick={() => handleSorting("asking_price")}>
            ASK PRICE
            {sortConfig.key === "asking_price" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span onClick={() => handleSorting("brand")}>
            BRAND
            {sortConfig.key === "brand" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          {/* <span onClick={() => handleSorting("warranty")}>
            WARRANTY
            {sortConfig.key === "warranty" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span> */}
          <span onClick={() => handleSorting("address")}>
            CITY
            {sortConfig.key === "address" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span onClick={() => handleSorting("change_owner")}>
            CHANGE OWNER
            {sortConfig.key === "address" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span >
            PRODUCT DES

          </span>
          <span onClick={() => handleSorting("product_status")}>
            STATUS
            {sortConfig.key === "product_status" && (sortConfig.direction === "asc" ? <AiOutlineUp style={sortIconStyle} /> : <AiOutlineDown style={sortIconStyle} />)}
          </span>
          <span>DETAIL</span>
        </div>


        {usedAdslistData.length > 0 ? (
          usedAdslistData.map((data, index) => {
            return (
              <div className={styles.itemData} key={index}>
                <span>{data?.id}</span>
                <span>{data?.seller_name}</span>
                <span>{data?.seller_firstname}</span>
                <span
                  onClick={() => window.open(`https://www.equipmedy.com/${data?.slug}`, '_blank', 'noopener,noreferrer')}
                  className="cursor-pointer"
                >{data?.equip_name}</span>
                <span>{data?.category_list}</span>
                <span>{data?.speciality_name?.slice(0, 10)}</span>
                <span>{parseFloat(data?.asking_price).toFixed(2)}</span>
                <span>{data?.brand}</span>
                {/* <span>{data?.warranty === 1 ? "Yes" : "No"}</span> */}
                <span>{data?.address?.slice(0, 20)}</span>
                <span className="cursor-pointer bg-green-600 text-white py-1 rounded-full"
                  onClick={() => navigate("/admin/change-owner/", { state: { data: data } })}
                >Change</span>
                <span
                  className="cursor-pointer bg-green-600 text-white py-1 rounded-full"
                  onClick={() => navigate("/admin/product-description/", {
                    state: {
                      data: data,
                      type: "product"
                    }
                  })}
                >Add</span>
                <span>
                  <span className={common.customStyle}>
                    {data?.product_status === 1
                      ? "OPEN"
                      : data?.product_status === 2
                        ? "LOCK"
                        : data?.product_status === 3
                          ? "Selled"
                          : data?.product_status === 4
                            ? "PENDING"
                            : ""}
                  </span>
                </span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => handleView(e, data)}
                >
                  View
                </span>
              </div>
            );
          })
        ) : (
          <div className="flex items-center justify-center text-gray-500 py-4">
            <i className="bi bi-search text-[#019c89] mr-2 text-lg"></i>
            <span>No results found</span>
          </div>
        )}

      </div>
      <Pagination
        total={paging?.total}
        perPage={itemsPerPage}
        setPerPage={setItemsPerPage}
        currPage={currPage}
        prevPage={prevPage}
        tPage={paging?.total_pages}
        updatePage={updatePage}
        setCurrPage={setCurrPage} // Add this prop
      />

      {loader && <Loader />}
    </section>
  );
};